import { IItem, IItemData } from '../item.types';
import { Item } from '../item';

export const mockItemsData = (): IItemData[] => [
  {
    item: '1000003',
    description: 'FAN ASSEMBLY - P2 BASE DESIGN',
    unit: 'EA',
    abc_code: 'C',
    unit_cost: 0.01032,
    family_code: 'PRINT',
    last_gen_date: '2021-03-16 04:06:00',
    is_phantom: false,
    price: 0,
    manually_created: false,
    hs_code: 'test',
    country_of_origin: 'JA',
    is_machine: false,
    is_obsolete: false,
    is_valid_price: true
  },
  {
    item: '1000004',
    description: 'SENSOR - CO2',
    unit: 'EA',
    abc_code: 'C',
    unit_cost: 132.56507643,
    family_code: 'EL',
    last_gen_date: '2021-03-16 04:06:00',
    is_phantom: false,
    price: 344.0,
    manually_created: false,
    hs_code: 'test',
    country_of_origin: 'JA',
    is_machine: false,
    is_obsolete: false,
    is_valid_price: true
  }
];

export const mockItems = (data: IItemData[] = mockItemsData()): IItem[] =>
  data.map(item => new Item(item));
